import { render, staticRenderFns } from "./CardTarjaEnqueteCopaTVFechada.vue?vue&type=template&id=5c8a5329&scoped=true"
import script from "./CardTarjaEnqueteCopaTVFechada.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteCopaTVFechada.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteCopaTVFechada.vue?vue&type=style&index=0&id=5c8a5329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a5329",
  null
  
)

export default component.exports